import { useState } from "react";

export function useGeolocation() {
  const [isLoading, setIsLoading] = useState(false);
  const [position, setPosition] = useState({});
  const [error, setError] = useState(null);

  function getPosition() {
    if (!navigator.geolocation)
      return setError("Your browser does not support geolocation");

    setIsLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
        setIsLoading(false);
      },
      (error) => {
        if (error) {
          throw new Error(
            "Network error. Check your Internet connection DevTools console for more information."
          );
        }
        setIsLoading(false);
        setError(error.message);
        console.log(error.message);
      }
    );
  }

  return { position, getPosition, isLoading, error };
}
